// México: 32 entidades federativas (nivel 1) + municipios (nivel 2).
// El nivel 2 incluye las capitales/ciudades principales como seed;
// el catálogo municipal completo (~2,470) se carga desde INEGI antes del go-live.
export const geoDataMX = {
    states: [
        { id: 0, name: "Seleccione Estado" },
        { id: 1, name: "Aguascalientes" },
        { id: 2, name: "Baja California" },
        { id: 3, name: "Baja California Sur" },
        { id: 4, name: "Campeche" },
        { id: 5, name: "Coahuila" },
        { id: 6, name: "Colima" },
        { id: 7, name: "Chiapas" },
        { id: 8, name: "Chihuahua" },
        { id: 9, name: "Ciudad de México" },
        { id: 10, name: "Durango" },
        { id: 11, name: "Guanajuato" },
        { id: 12, name: "Guerrero" },
        { id: 13, name: "Hidalgo" },
        { id: 14, name: "Jalisco" },
        { id: 15, name: "Estado de México" },
        { id: 16, name: "Michoacán" },
        { id: 17, name: "Morelos" },
        { id: 18, name: "Nayarit" },
        { id: 19, name: "Nuevo León" },
        { id: 20, name: "Oaxaca" },
        { id: 21, name: "Puebla" },
        { id: 22, name: "Querétaro" },
        { id: 23, name: "Quintana Roo" },
        { id: 24, name: "San Luis Potosí" },
        { id: 25, name: "Sinaloa" },
        { id: 26, name: "Sonora" },
        { id: 27, name: "Tabasco" },
        { id: 28, name: "Tamaulipas" },
        { id: 29, name: "Tlaxcala" },
        { id: 30, name: "Veracruz" },
        { id: 31, name: "Yucatán" },
        { id: 32, name: "Zacatecas" }
    ],
    municipalities: [
        { provinceId: 0, id: 0, name: "Seleccione Municipio", code: 0 },
        { provinceId: 1, id: 1, name: "Aguascalientes", code: 101 },
        { provinceId: 2, id: 2, name: "Mexicali", code: 201 },
        { provinceId: 2, id: 3, name: "Tijuana", code: 202 },
        { provinceId: 2, id: 4, name: "Ensenada", code: 203 },
        { provinceId: 3, id: 5, name: "La Paz", code: 301 },
        { provinceId: 3, id: 6, name: "Los Cabos", code: 302 },
        { provinceId: 4, id: 7, name: "Campeche", code: 401 },
        { provinceId: 5, id: 8, name: "Saltillo", code: 501 },
        { provinceId: 5, id: 9, name: "Torreón", code: 502 },
        { provinceId: 6, id: 10, name: "Colima", code: 601 },
        { provinceId: 6, id: 11, name: "Manzanillo", code: 602 },
        { provinceId: 7, id: 12, name: "Tuxtla Gutiérrez", code: 701 },
        { provinceId: 7, id: 13, name: "San Cristóbal de las Casas", code: 702 },
        { provinceId: 8, id: 14, name: "Chihuahua", code: 801 },
        { provinceId: 8, id: 15, name: "Ciudad Juárez", code: 802 },
        { provinceId: 9, id: 16, name: "Álvaro Obregón", code: 901 },
        { provinceId: 9, id: 17, name: "Azcapotzalco", code: 902 },
        { provinceId: 9, id: 18, name: "Benito Juárez", code: 903 },
        { provinceId: 9, id: 19, name: "Coyoacán", code: 904 },
        { provinceId: 9, id: 20, name: "Cuajimalpa de Morelos", code: 905 },
        { provinceId: 9, id: 21, name: "Cuauhtémoc", code: 906 },
        { provinceId: 9, id: 22, name: "Gustavo A. Madero", code: 907 },
        { provinceId: 9, id: 23, name: "Iztacalco", code: 908 },
        { provinceId: 9, id: 24, name: "Iztapalapa", code: 909 },
        { provinceId: 9, id: 25, name: "La Magdalena Contreras", code: 910 },
        { provinceId: 9, id: 26, name: "Miguel Hidalgo", code: 911 },
        { provinceId: 9, id: 27, name: "Milpa Alta", code: 912 },
        { provinceId: 9, id: 28, name: "Tláhuac", code: 913 },
        { provinceId: 9, id: 29, name: "Tlalpan", code: 914 },
        { provinceId: 9, id: 30, name: "Venustiano Carranza", code: 915 },
        { provinceId: 9, id: 31, name: "Xochimilco", code: 916 },
        { provinceId: 10, id: 32, name: "Durango", code: 1001 },
        { provinceId: 11, id: 33, name: "Guanajuato", code: 1101 },
        { provinceId: 11, id: 34, name: "León", code: 1102 },
        { provinceId: 11, id: 35, name: "Irapuato", code: 1103 },
        { provinceId: 11, id: 36, name: "Celaya", code: 1104 },
        { provinceId: 12, id: 37, name: "Chilpancingo de los Bravo", code: 1201 },
        { provinceId: 12, id: 38, name: "Acapulco de Juárez", code: 1202 },
        { provinceId: 13, id: 39, name: "Pachuca de Soto", code: 1301 },
        { provinceId: 14, id: 40, name: "Guadalajara", code: 1401 },
        { provinceId: 14, id: 41, name: "Zapopan", code: 1402 },
        { provinceId: 14, id: 42, name: "San Pedro Tlaquepaque", code: 1403 },
        { provinceId: 14, id: 43, name: "Tonalá", code: 1404 },
        { provinceId: 14, id: 44, name: "Puerto Vallarta", code: 1405 },
        { provinceId: 15, id: 45, name: "Toluca", code: 1501 },
        { provinceId: 15, id: 46, name: "Ecatepec de Morelos", code: 1502 },
        { provinceId: 15, id: 47, name: "Naucalpan de Juárez", code: 1503 },
        { provinceId: 15, id: 48, name: "Nezahualcóyotl", code: 1504 },
        { provinceId: 15, id: 49, name: "Tlalnepantla de Baz", code: 1505 },
        { provinceId: 16, id: 50, name: "Morelia", code: 1601 },
        { provinceId: 17, id: 51, name: "Cuernavaca", code: 1701 },
        { provinceId: 18, id: 52, name: "Tepic", code: 1801 },
        { provinceId: 19, id: 53, name: "Monterrey", code: 1901 },
        { provinceId: 19, id: 54, name: "Guadalupe", code: 1902 },
        { provinceId: 19, id: 55, name: "San Nicolás de los Garza", code: 1903 },
        { provinceId: 19, id: 56, name: "San Pedro Garza García", code: 1904 },
        { provinceId: 19, id: 57, name: "Apodaca", code: 1905 },
        { provinceId: 20, id: 58, name: "Oaxaca de Juárez", code: 2001 },
        { provinceId: 21, id: 59, name: "Puebla", code: 2101 },
        { provinceId: 22, id: 60, name: "Querétaro", code: 2201 },
        { provinceId: 23, id: 61, name: "Othón P. Blanco (Chetumal)", code: 2301 },
        { provinceId: 23, id: 62, name: "Benito Juárez (Cancún)", code: 2302 },
        { provinceId: 23, id: 63, name: "Solidaridad (Playa del Carmen)", code: 2303 },
        { provinceId: 24, id: 64, name: "San Luis Potosí", code: 2401 },
        { provinceId: 25, id: 65, name: "Culiacán", code: 2501 },
        { provinceId: 25, id: 66, name: "Mazatlán", code: 2502 },
        { provinceId: 26, id: 67, name: "Hermosillo", code: 2601 },
        { provinceId: 26, id: 68, name: "Ciudad Obregón (Cajeme)", code: 2602 },
        { provinceId: 27, id: 69, name: "Centro (Villahermosa)", code: 2701 },
        { provinceId: 28, id: 70, name: "Ciudad Victoria", code: 2801 },
        { provinceId: 28, id: 71, name: "Reynosa", code: 2802 },
        { provinceId: 28, id: 72, name: "Matamoros", code: 2803 },
        { provinceId: 28, id: 73, name: "Tampico", code: 2804 },
        { provinceId: 29, id: 74, name: "Tlaxcala", code: 2901 },
        { provinceId: 30, id: 75, name: "Xalapa", code: 3001 },
        { provinceId: 30, id: 76, name: "Veracruz", code: 3002 },
        { provinceId: 31, id: 77, name: "Mérida", code: 3101 },
        { provinceId: 32, id: 78, name: "Zacatecas", code: 3201 }
    ]
};
